import { Outlet } from "react-router-dom";

const BlogPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default BlogPageLayout;
